import { gql } from "apollo-angular";
import { ILLINKSnippet } from "./template-nav-links";

export const linkFragment = gql`
  fragment LINK on Link {
    linkTitle
    externalLink
    internalLink {
        ${ILLINKSnippet}
    }
    docLink {
      ...DOCLNK
    }
    linkTarget
    submenu {
      ...SUBM
    }
  }
`

export const SUBMENU_FRAGMENT = gql`
  fragment SUBM on Submenu {
    linksCollection(limit: 10) {
      items{
        linkTitle
        externalLink
        internalLink {
          ${ILLINKSnippet}
        }
        docLink {
          ...DOCLNK
        }
        linkTarget
      }
    }
  }
`